// Loaded before timerhook by the host: tool pacing stays in real milliseconds.
const nativeSetTimeout = window.setTimeout.bind(window)
const nativeClearTimeout = window.clearTimeout.bind(window)
export const toolsSetTimeout = nativeSetTimeout
export const toolsClearTimeout = nativeClearTimeout

export function createRunner({ execute, identity, onState, schedule = nativeSetTimeout, cancel = nativeClearTimeout }) {
  let state = 'idle', generation = 0, timer = null, config = null, point = 0, loops = 0, owner = null
  const emit = message => onState({ state, point, loops, message: message || '' })
  const clear = () => { if (timer !== null) cancel(timer); timer = null }
  function stop(message = '已停止') { generation++; clear(); state = 'idle'; emit(message) }
  function next() {
    if (state !== 'running') return
    const epoch = generation
    timer = schedule(async () => {
      timer = null
      if (state !== 'running' || epoch !== generation) return
      if (identity() !== owner) { stop('游戏或账号已变化，请重新开始'); return }
      try {
        const issuingConfig = config
        await execute(config.points[point])
        if (config !== issuingConfig || !['running','paused'].includes(state)) return
        point++
        if (point >= config.points.length) { point = 0; loops++ }
        if (config.loops && loops >= config.loops) { clear(); state = 'completed'; emit('本次运行完成'); return }
        if (state !== 'running' || epoch !== generation) { emit('已暂停'); return }
        emit(); next()
      } catch (error) {
        if (epoch !== generation) return
        clear(); state = 'error'; emit(error.message || '执行失败')
      }
    }, config.points[point].delay)
  }
  return {
    start(task, count) {
      if (state === 'running' || state === 'paused') throw new Error('请先停止当前任务')
      if (!Number.isInteger(count) || count < 0 || count > 100) throw new Error('运行次数需为 1 至 100，或选择循环运行')
      generation++; clear(); config = { points: task.points.map(p => ({ ...p })), loops: count }; point = 0; loops = 0; owner = identity(); state = 'running'; emit(); next()
    },
    pause() { if (state !== 'running') return; generation++; clear(); state = 'paused'; emit('已暂停') },
    resume() {
      if (state !== 'paused') return
      if (identity() !== owner) { stop('游戏或账号已变化，请重新开始'); return }
      generation++; state = 'running'; emit(); next()
    }, stop,
    destroy() { stop('已退出工具') },
  }
}
